import { Redirect } from "expo-router";
import type { BookingStoreSnapshotOut } from "~/mobx/entities/booking/BookingStore";
import { useStore } from "~/mobx/utils/useStore";
import { useStandaloneBookingFlow } from "./useStandaloneBookingFlow";

type BookingStoreKeys = keyof BookingStoreSnapshotOut;

export const withBookingData = (
  Component: React.ComponentType<any>,
  requiredData: BookingStoreKeys[],
) => {
  return function WithBookingData() {
    const store = useStore();
    const { isStandAloneBookingFlow, clinicId, isNewUser } =
      useStandaloneBookingFlow();
    const bookingStore = store.bookingStore;

    for (const field of requiredData) {
      if (!bookingStore[field]) {
        if (isStandAloneBookingFlow) {
          return (
            <Redirect
              href={{
                pathname: "/(standalone)/booking",
                params: {
                  clinicId,
                  isNewUser: isNewUser ? "1" : "0",
                },
              }}
            />
          );
        }

        return <Redirect href="/(app)/book-appointment" />;
      }
    }

    return <Component />;
  };
};
